// extracted by mini-css-extract-plugin
export default {"description":"YtteGf1woOuZVR7xgElQ"};